import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../services/user.service';
import { ConfigService } from '../../services/config.service';

/**
 * Component for editing browse path metadata values.
 */
@Component({
	selector: 'email-modal',
	templateUrl: './email-modal.component.html',
	styleUrl: './email-modal.component.css'
})
export class EmailModalComponent implements OnInit {
	LOCALIZATION: any;
	
	emailsList: any[] = [];
	selectedValues: string[] = [];

	constructor(
		private ngbmodalService: NgbActiveModal,
		private userService: UserService,
		private configService: ConfigService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.emailsList = this.configService.getConfig().upload.notificationEmails;
	}

	update(): void {
		this.ngbmodalService.close(this.selectedValues.join(',') ?? '');
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
